module.exports = __webpack_public_path__ + "static/media/background_inicio_ebmi_movil.50b13f32.png";